import _merge from 'lodash/merge';
import { t } from '../../i18n';
import { EXIT_APP_SIGNAL, HIDE_POPUP_SIGNAL, ROUTE_BACK_SIGNAL } from '../../popupContainer/popupContainer.constants';
import { Button } from '../../tornado/button/button.component';
import { BrandIcon } from '../../tornado/brand-icon/brandIcon.component';
import { AbstractPopup } from '../abstractPopup/abstractPopup.component';
import { getInitialStyle } from './accountCompletionPopup.style';

export class AccountCompletionPopup extends AbstractPopup {
  static _template() {
    return _merge(getInitialStyle(), {
      Icon: {
        type: BrandIcon,
      },
      FlexContainer: {
        Title: {
          text: {
            text: t('pairing.completion.title'),
          },
        },
        Description: {
          text: {
            text: t('pairing.completion.description'),
          },
        },
        OkButton: {
          type: Button,
          label: t('global.close'),
        },
      },
      passSignals: {
        [HIDE_POPUP_SIGNAL]: true,
        [ROUTE_BACK_SIGNAL]: true,
        [EXIT_APP_SIGNAL]: true,
      },
    });
  }

  _active() {
    this.tag('OkButton').label = this._getCloseButtonCaption();
  }

  _getFocused() {
    return this.tag('OkButton');
  }

  _handleEnter() {
    this.signal(this._getCloseActionSignal());

    return true;
  }

  _getCloseButtonCaption() {
    switch (this._getCloseActionSignal()) {
      case EXIT_APP_SIGNAL:
        return t('global.quit');
      case ROUTE_BACK_SIGNAL:
      default:
        return t('global.back');
    }
  }
}
